// axiosInstance.js
import axios from 'axios';

const csrfToken = document.querySelector('meta[name="csrf-token"]')?.content;

const axiosInstance = axios.create({
  headers: {
    'X-CSRF-Token': csrfToken,
    'Content-Type': 'application/json',
  },
  withCredentials: true, // 쿠키 사용 시
});

// 401 에러 처리를 위한 응답 인터셉터 추가
axiosInstance.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response && error.response.status === 401) {
      // 401 Unauthorized 에러 시 로그인 페이지로 리다이렉트
      const currentPath = window.location.pathname;
      window.location.href = `/users/sign_in?return_to=${encodeURIComponent(currentPath)}`;
    }
    return Promise.reject(error);
  }
);

export default axiosInstance;
